import { CategoryModel } from '@modules/category/category-model';

const fields  = new CategoryModel().fields();

export default [
  fields.id,
  fields.name,
  fields.createdAt,
  fields.updatedAt
];
